import { ITranslations } from './translations.interface'

const privacyPolicyLink = 'https://www.travelski.com/instit/donnees-personnelles'
const partnersLink = `<a href='${privacyPolicyLink}' target='_blank' rel='noopener'>nos partenaires</a>`

const translations: ITranslations = {
  navbar: {
    greeting: 'Bonjour',
    confirmed: 'Réservations',
    quotes: 'Recherches sauvegardées',
    profile: 'Profil',
    logout: 'Déconnexion',
  },
  loginRegister: {
    login_page_title: 'Compte Client',
    log_in_or_register: 'Connectez-vous ou inscrivez-vous pour réserver',
    login_register: 'Connexion / Inscription',
    email_not_valid: 'Votre adresse e-mail est incorrecte',
    user_info_mandatory_field: 'Champ obligatoire',
    user_info_invalid_phone: 'Format invalide.',
    user_info_invalid_phone_length:
      'Format invalide. Le numéro de téléphone doit contenir {count} chiffres.',
    user_info_invalid_phone_length_range:
      'Format invalide. Le numéro de téléphone doit contenir {min} à {max} chiffres.',
    user_info_invalid_phone_length_start_zero:
      'Format invalide. Le numéro de téléphone doit contenir {count} chiffres et commencer par 0.',
    new_password_forgot_password: 'Mot de passe oublié ?',
    new_password_create_new_password: 'Créez votre nouveau mot de passe',
    new_password1: 'Nouveau mot de passe',
    new_password2: 'Confirmer votre mot de passe',
    user_info_forgot_password: 'Mot de passe oublié ?',
    user_info_already_have_account: 'Vous avez déjà un compte ?',
    user_info_enter_email:
      'Cliquez sur Envoyer pour réinitialiser votre mot de passe',
    user_info_email_sent:
      'Un lien pour réinitialiser votre mot de passe a été envoyé à',
    user_info_new_password: 'Indiquez votre nouveau mot de passe',
    send: 'Envoyer',
    validate: 'Validez',
    i_want_to_register: 'Je veux créer un compte',
    i_want_to_login: 'Je veux me connecter',
    new_password_succes: 'Votre mot de passe a été réinitialisé avec succès',
    login: 'Connexion',
    user_info_your_informations: 'Vos informations',
    contacts_first_name: 'Prénom',
    contacts_last_name: 'Nom',
    contacts_email: 'E-mail',
    contacts_other_email: 'Se connecter avec un autre e-mail',
    contacts_password1: 'Mot de passe',
    contacts_password2: 'Confirmez votre mot de passe',
    contacts_password_format: 'Votre mot de passe doit',
    contacts_password_format_lenght: 'Contenir au minimum 8 caractères',
    contacts_password_format_lowercase: 'Contenir au moins 1 minuscule',
    contacts_password_format_uppercase: 'Contenir au moins 1 majuscule',
    contacts_password_format_number: 'Contenir au moins 1 chiffre',
    contacts_password_format_character:
      'Contenir au moins 1 caractère spécial (# ; @ ; $ ...)',
    contacts_passwords_dont_match: 'Le mot de passe ne correspond pas',
    contacts_email_is_not_valid: 'L’e-mail n’est pas valide',
    user_info_to_contact_you: 'Vous joindre',
    contacts_address: 'Adresse',
    contacts_city: 'Ville',
    contacts_country: 'Pays',
    contacts_postal_code: 'Code postal',
    contacts_phone_number: '00 00 00 00 00',
    contacts_subscribe_newsletter:
      'Je m’abonne à la Newsletter de Travelski.com et je profite des promotions, ventes flash et avantages fidélité !',
    contacts_accept_conditions1: 'J’ai lu et j’accepte les',
    contacts_accept_conditions2: 'Conditions Générales de Vente',
    contacts_accept_conditions3:
      'et je suis informé de l’absence de droit de rétractation.',
    update_my_details: 'Mettre à jour mes coordonnées',
    continue_with_these_contacts: 'Continuer avec ces informations',
    user_info_create_account: 'Créez un compte',
    user_info_is_it_first_time:
      'Vous partez avec Travelski pour la 1ère fois ?',
    contacts_incorrect_credentials: 'Vos identifiants sont incorrects',
    error_wrong_email: 'L’adresse e-mail saisie est invalide. Veuillez vérifier l’e-mail renseigné et réessayer.',
    register_call_center_modal_title: 'Besoin d’aide ?',
    register_call_center_modal_message: 'Notre centre d’appel est disponible aux horaires suivants pour vous aider à finaliser votre réservation.',
    register_call_center_modal_phone: 'Téléphone',
    register_call_center_modal_opening_hours: 'Horaires du centre d’appel',
    register_call_center_modal_call_button: 'Appeler le centre d’appel',
    mister: 'M.',
    madam: 'Mme',
    link_expired: 'Votre lien a expiré',
    text_resend_link:
      'Votre lien de réinitialisation de mot de passe a expiré. Veuillez cliquer sur le bouton ci-dessous pour en recevoir un nouveau.',
    button_resend_link: 'Me renvoyer le lien',
    keepInTouch: {
      title: 'Gardez le contact',
      emailDealsLabel: 'Bons plans email et personnalisation',
      emailDealsDesc:
        "Remises exclusives, baisses de prix, early booking, suivi des ouvertures d'emails.",
      partenairesLabel: 'Avantages Partenaires',
      partenairesDesc: `Nouveautés et avantages de ${partnersLink} (envoyés par travelski).`,
      personalize: 'Personnaliser en détail',
      personalizeTitle: 'Préférences de communication',
      sectionDealsTitle: 'Bons plans travelski',
      sectionDealsIntro:
        'Remises exclusives, early booking et baisses de prix. Désinscription possible à tout moment.',
      sectionPartnersTitle: 'Partenaires du groupe',
      sectionPartnersIntro: `Nouveautés portant sur les produits et services des partenaires Compagnie des Alpes de Travelski, ainsi que l’utilisation de dispositifs permettant de mesurer l’ouverture de ces e-mails afin d’améliorer et personnaliser les communications qui vous sont adressées. Toutes les communications seront envoyées par Travelski, vos données restent avec nous et ne sont pas partagées avec ${partnersLink}, comme le Futuroscope, Les Arcs, La Plagne…`,
      sectionTrackingTitle: 'Personnalisation des emails',
      sectionTrackingIntro:
        "Permet de mesurer l'ouverture des emails via des pixels de suivi afin d’éviter les relances inutiles, d’améliorer et personnaliser les communications qui vous sont adressées et mesurer la performance de nos campagnes. Retrait possible en 1 clic à tout moment depuis une newsletter ou votre espace client.",
      switchEmail: 'Email',
      switchEmailDesc: 'Le meilleur canal pour recevoir des offres et alertes prix.',
      switchTracking: 'Suivi des ouvertures',
      switchTrackingDesc: 'Mesure si un email a été ouvert (pixel de suivi).',
      switchPartenaires: 'Communications partenaires (email)',
      switchPartenairesDesc: `Toutes les communications seront envoyées par Travelski, vos données restent avec nous et ne sont pas partagées avec ${partnersLink}.`,
      switchSms: 'SMS',
      switchSmsDesc: 'Rappels courts et informations importantes.',
      save: 'Enregistrer',
      back: 'Retour',
    },
  },
  reservations: {
    pageTitle: 'Mes réservations',
    participant: 'participant | participants', // pluralization
    until: 'au',
    pastBookings: 'Mes anciens séjours',
    noBooking: 'Pas de séjour réservé ... pour l’instant !',
    timeToChoose:
      'Où passerez-vous vos prochaines vacances au ski ? Il est temps de choisir !',
    search: 'Lancer une recherche',
    reference: 'Référence de dossier',
    viewDetails: 'Voir le détail',
    payBalance: 'Payer le Solde',
    prestId: 'Référence du logement:',
    participantInfo: 'Information participant à remplir',
    summaryTitle: 'Récapitulatif de ma réservation',
    missingTravellerInfoWarning: 'Information participant à remplir',
    nextStay: 'Mon prochain séjour',
    eurostarTitle: 'Récupérez vos billets Eurostar',
    eurostarBody:
      'Vos billets de train seront disponibles sur le site Eurostar une fois vos informations voyageurs renseignées. Connectez-vous avec votre référence de réservation Eurostar et votre nom de famille, puis complétez les informations demandées pour accéder à vos e-billets.',
    eurostarReference: 'Référence Eurostar :',
    eurostarCta: 'Récupérer mes billets Eurostar',
    // Quotes
    formula: 'Formule',
    equipment: 'Matériel',
    train: 'Train',
    flight: 'Vol',
    taxi: 'Taxi',
    bus: 'Bus',
    funicular: 'Funiculaire',
    serviceHours24: 'Service 24h/24',
    luggage: 'Bagages',
    luggageBothWays: 'aller-retour',
    luggageOutboundOnly: 'aller uniquement',
    luggageInboundOnly: 'retour uniquement',
    transport: 'Train + Tranfert',
    outbound: 'Aller :',
    return: 'Retour :',
    class: 'classe',
    transfer: 'Transfert',
    accommodation: 'Hébergement',
    skipass: 'Skipass',
    skipassShort: 'Skipass Court Séjour',
    equipmentShort: 'Matériel Court Séjour',
    FeeIncluded: 'Frais de service inclus',
    viewQuote: 'Voir le détail de l’hébergement',
    // Booking Panel
    helmet: 'Casque',
    option: 'Options',
    proceedToAvailability: 'Voir la disponibilité du logement',
    total: 'Total',
    reserve: 'Réserver',
    payDeposit: "Payer l'acompte",
    reserveActionsDepositHint: 'Poursuivre sur le parcours de réservation',
    reserveActionsPaymentsSection: 'Liens de paiement à régler',
    reserveActionsPaymentLinkTitle: 'Lien de paiement',
    paymentLinkTitle: 'Lien de paiement {n}',
    echeanceTitle: 'Échéance {n}',
    echeanceTitleSingle: 'Échéance',
    reserveActionsDueBy: 'à régler avant le {date}',
    payPaymentLink: 'Payer {amount}',
    payPaymentLinkWithDate: 'Payer {amount} (avant le {date})',
    payPaymentLinkInstalment: 'Payer le lien de paiement {n} — {amount}',
    payPaymentLinkInstalmentWithDate:
      'Payer le lien de paiement {n} — {amount} (avant le {date})',
    reserveActionsTitle: 'Que souhaitez-vous faire ?',
    iresaPendingNotice:
      'Votre réservation est en cours de transfert vers iResa. Certaines actions peuvent être temporairement indisponibles.',
    cancel: 'Annuler',
  },
  documents: {
    title: 'Documents de séjour',
    'booking-confirmation': 'Confirmation de réservation',
    'booking-confirmation-available': 'Disponible',
    'booking-confirmation-flight': 'Confirmation de réservation',
    'booking-confirmation-flight-available': 'Disponible',
    'booking-confirmation-train': 'Confirmation de réservation',
    'booking-confirmation-train-available': 'Disponible',
    vouchers: 'Documents de voyage',
    'vouchers-available': 'Disponible 10 jours avant le séjour',
    invoice: 'Facture acquittée',
    'invoice-available': 'Disponible après le séjour',
    other: 'Autres documents',
    'other-available': 'Disponible',
    'insurance': 'Assurance annulation',
    'insurance-available': 'Disponible',
    cancellation_insurance_certificate: 'Document d’assurance',
    'cancellation_insurance_certificate-available': 'Disponible',
    cancellation_insurance_certificatev2: 'Document d’assurance',
    'cancellation_insurance_certificatev2-available': 'Disponible',
    'insurance-skieur': 'Assurance Skieur',
    'insurance-skieur-available': 'Disponible',
    'insurance-annulation': 'Assurance annulation Zen',
    'insurance-annulation-cosog': 'Garantie annulation',
    'insurance-annulation-available': 'Disponible',
    'insurance-annulation-cosog-available': 'Disponible',
    'flight_tickets': 'Billets d\'avion',
    'flight_tickets-available': 'Disponible',
    'flight_tickets_aller': 'Billets d\'avion (aller)',
    'flight_tickets_aller-available': 'Disponible',
    'flight_tickets_retour': 'Billets d\'avion (retour)',
    'flight_tickets_retour-available': 'Disponible',
    'flight_tickets_change': 'Changement d\'horaire vol',
    'flight_tickets_change-available': 'Disponible',
    'skier_insurance_certificate': 'Certificat d’assurance skieur',
    'skier_insurance_certificate-available': 'Disponible',
    'altibus_ticket_aller': 'Billets de bus (aller)',
    'altibus_ticket_aller-available': 'Disponible',
    'altibus_ticket_retour': 'Billets de bus (retour)',
    'altibus_ticket_retour-available': 'Disponible',
    'bensbus_ticket': 'Billets de bus',
    'bensbus_ticket-available': 'Disponible',
    'bensbus_ticket_aller': 'Billets de bus (aller)',
    'bensbus_ticket_aller-available': 'Disponible',
    'bensbus_ticket_retour': 'Billets de bus (retour)',
    'bensbus_ticket_retour-available': 'Disponible',
    'tne_eticket_aller': 'Billets de train (aller)',
    'tne_eticket_aller-available': 'Disponible',
    'tne_eticket_retour': 'Billets de train (retour)',
    'tne_eticket_retour-available': 'Disponible',
    download: 'Télécharger',
    claimTitle: 'Pour déclarer un sinistre et suivre sa progression',
    myInsuredArea: 'Mon espace assuré',
    noDocuments: 'Aucun document disponible pour cette réservation.',
  },
  
  payments: {
    title: 'Paiement du solde',
    flexProduct: 'Flex',
    flexTitle: 'La flexibilité',
    flexDescription:
      'Annulation et modification avec frais.',
    fixedProduct: 'Fixe',
    fixedTitle: 'Le meilleur prix',
    fixedDescription: 'Non remboursable.',
    totalPrice: 'Total',
    depositToPay: 'Acompte à régler',
    leftToPay: 'Solde à régler',
    totalPaid: 'Acompte (déjà payé)',
    termsAndConditions: 'Conditions générales de vente'
  },
  travellers: {
    title: 'Participants',
    age: 'Date de naissance',
    firstName: 'Prénom',
    lastName: 'Nom',
    modifyInformation: 'Modifier les informations',
    modifyNotAllowedMessageBefore: 'Pour modifier les informations des voyageurs, veuillez contacter le service client à',
    modifyNotAllowedMessageAfter: '(des frais peuvent s\'appliquer)',
    traveller: 'Participant',
    panelIntro:
      'Veuillez renseigner les noms, prénoms et âges de chaque participant pour profiter des meilleurs tarifs.',
    yearsOld: 'ans',
  },
  needHelp: {
    title: 'Besoin d’aide ? ',
    description:
      'Une question ? Nous sommes là pour vous répondre.',
    contact: 'Nous contacter',
  },
  panels: {
    confirm: 'Validez votre sélection',
  },
  errorMessages: {
    fieldMandatory: 'Champ obligatoire',
    atLeastOne18: 'Au moins un voyageur doit avoir 18 ans',
    updateUserInfo: "échec de la mise à jour de l'utilisateur",
    changePassword: 'La modification du mot de passe a échoué.',
    fetchBookings:
      'Une erreur est survenue lors de la récupération des réservations.',
    fetchLihes: 'Une erreur est survenue lors de la récupération des lignes.',
    fetchProductURL:
      "Une erreur est survenue lors de la récupération de l'URL du produit.",
    fetchServices:
      'Une erreur est survenue lors de la récupération des services.',
    getDocuments:
      'Une erreur est survenue lors de la récupération des documents.',
    login: 'Une erreur est survenue lors de la connexion.',
    logout: 'Une erreur est survenue lors de la déconnexion.',
    newPassword:
      'Une erreur est survenue lors de la création du nouveau mot de passe.',
    refresh: 'Une erreur est survenue lors du rafraîchissement de la session.',
    resetPassword:
      'Une erreur est survenue lors de la réinitialisation du mot de passe.',
    search: 'Une erreur est survenue lors de la recherche.',
    register: "Une erreur est survenue lors de l'inscription.",
    selectBooking:
      'Une erreur est survenue lors de la sélection de la réservation.',
    unselectBooking:
      'Une erreur est survenue lors de la désélection de la réservation.',
    updateTraveller:
      'Une erreur est survenue lors de la mise à jour des informations du voyageur.',
    validateTokens: '',
    handleBookingUILogin: '',
    handleCustomerUILogin: '',
  },
  successMessages: {
    resetPasswordSuccess: '',
  },
  quotes: {
    pageTitle: 'Recherches sauvegardées',
    noQuote: 'Pas de recherche sauvegardée ... pour le moment !',
    timeToChoose:
      'Vous avez trouvé un séjour qui vous plaît ? Sauvegardez votre recherche et revenez réserver quand vous voulez !',
  },
  profile: {
    pageTitle: 'Mon profil',
    settingsTitle: 'Paramètre du compte',
    infoTitle: 'Besoin d’aide ?',
    myInfo: 'Mes coordonnées',
    resetPassword: 'Mot de passe',
    savePassword: 'Enregistrer',
    savingPassword: 'Enregistrement en cours',
    currentPasswordPlaceholder: 'Mot de passe actuel',
    newPasswordPlaceholder: 'Nouveau mot de passe',
    confirmPasswordPlaceholder: 'Confirmer le nouveau mot de passe',
    enterYourPassword:
      'Saisissez votre mot de passe actuel pour en définir un nouveau',
    modifyYourPassword: 'Modifier votre mot de passe',
    contactUs: 'Nous contacter',
    FAQ: 'Notre FAQ',
    legal: 'Nos CGV',
    communicationPreferences: {
      menuItem: 'Préférences de communication',
      title: 'Préférences de communication',
      loading: 'Chargement…',
      sectionDealsTitle: 'Bons plans travelski',
      sectionDealsIntro:
        'Remises exclusives, early booking et baisses de prix. Désinscription possible à tout moment.',
      sectionPartnersTitle: 'Partenaires du groupe',
      sectionPartnersIntro: `Nouveautés portant sur les produits et services des partenaires Compagnie des Alpes de Travelski, ainsi que l’utilisation de dispositifs permettant de mesurer l’ouverture de ces e-mails afin d’améliorer et personnaliser les communications qui vous sont adressées. Toutes les communications seront envoyées par Travelski, vos données restent avec nous et ne sont pas partagées avec ${partnersLink}, comme le Futuroscope, Les Arcs, La Plagne…`,
      sectionTrackingTitle: 'Personnalisation des emails',
      sectionTrackingIntro:
        "Permet de mesurer l'ouverture des emails via des pixels de suivi afin d’éviter les relances inutiles, d’améliorer et personnaliser les communications qui vous sont adressées et mesurer la performance de nos campagnes. Retrait possible en 1 clic à tout moment depuis une newsletter ou votre espace client.",
      switchEmail: 'Email',
      switchEmailDesc: 'Le meilleur canal pour recevoir des offres et alertes prix.',
      switchTracking: 'Suivi des ouvertures',
      switchTrackingDesc: 'Mesure si un email a été ouvert (pixel de suivi).',
      switchPartenaires: 'Communications partenaires (email)',
      switchPartenairesDesc: `Toutes les communications seront envoyées par Travelski, vos données restent avec nous et ne sont pas partagées avec ${partnersLink}.`,
      switchSms: 'SMS',
      switchSmsDesc: 'Rappels courts et informations importantes.',
      save: 'Enregistrer',
      back: 'Retour',
    },
    editInfoForm: {
      infoTitle: 'Vos informations',
      firstName: 'Prénom',
      lastName: 'Nom de famille',
      email: 'E-mail',
      emailChangeInfo:
        'Votre adresse email ne peut être modifiée car elle est liée à votre dossier et compte client.',
      contactsTitle: 'Vous joindre',
      address: 'Adresse',
      city: 'Ville',
      postalCode: 'Code postal',
      country: 'Pays',
      save: 'Enregistrer les modifications',
      phoneCode: 'Indicatif téléphonique', // Added "Country code"
      phoneNumber: 'Numéro de téléphone', // Added "Phone number"
    },
  },
  global: {
    pageTitle: "Compte"
  }
}

export default translations
